import React from 'react'
import { NFT } from '@thirdweb-dev/sdk'
import styles from './index.module.scss'

interface NftTraitsProps {
  nft: NFT
}

export interface NftTrait {
  trait_type: string
  value: string
}

export const NftTraitsHeader: React.FC = () => {
  return (
    <h1 className={ styles['nft-traits__title'] } >
      Traits
    </h1>
  )
}

export const NftTraitsMain: React.FC<NftTraitsProps> = ({ nft }) => {
  let traits = null

  // nft.metadata.attributes is of type
  //  { [x: string]: unknown }   |
  //  { [x: string]: unknown }[] |
  //  undefined
  //
  // Hence, we check if it's actually an array (as it must be in our case) in runtime.
  // Otherwise we have a programming error and we won't render any trait - but at least
  // the app won't crash.
  //
  if (typeof nft.metadata.attributes?.map === 'function') {
    traits = nft.metadata.attributes.map((trait: NftTrait) => {
      return (
        <li
          key={ trait.trait_type }
          className={ styles['nft-traits__item'] }
        >
          <span>{ trait.trait_type }:</span>
          <span>{ trait.value }</span>
        </li>
      )
    })
  } else if (typeof nft.metadata.properties === 'object' && nft.metadata.properties !== null) {
    traits = Object.entries(nft.metadata.properties).map(([key, value]) => {
      return (
        <li
          key={ key }
          className={ styles['nft-traits__item'] }
        >
          <span>{ key }:</span>
          <span>{ String(value) }</span>
        </li>
      )
    })
  } else {
    console.error(`Unexpected NFT traits "${JSON.stringify(nft.metadata.attributes)}"`)
  }

  return (
    <ul
      className={ `${styles['nft-traits__list']} ${traits?.length % 2 == 0 && styles['nft-traits__list--odd']}` }
    >
      { traits }
    </ul>
  )
}

export const NftTraits: React.FC<NftTraitsProps> = ({ nft }) => {
  return (
    <div
      data-testid="nft-traits"
      className={ styles['nft-traits'] }
    >
      <NftTraitsHeader/>

      <NftTraitsMain nft={ nft }/>
    </div>
  )
}
